import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../../css/Common.css';
import logo from '../../img/logo.webp';

export default function HeaderLoggedUser() {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = [
        { label: 'Il mio profilo', href: '/profilo' },
        { label: 'Richieste di preventivo', href: '/preventivi' },
        { label: 'Modifica profilo', href: '/modifica-profilo' },
        { label: 'Contatti', href: '/contatti' },
        { label: 'Esci', href: '/logout' }
    ];

    // Gestisce lo scroll agli ancoraggi
    useEffect(() => {
        if (location.hash) {
            // Usa requestAnimationFrame per assicurarsi che il DOM sia pronto
            requestAnimationFrame(() => {
                setTimeout(() => {
                    const id = location.hash.replace('#', '');
                    const elemento = document.getElementById(id);

                    if (elemento) {
                        // Calcola la posizione dell'elemento
                        const yOffset = -80; // offset per header fisso se ne hai uno
                        const y = elemento.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        // Scrolla alla posizione
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                }, 100);
            });
        }
    }, [location]);

    const handleClick = (e, href) => {
        e.preventDefault();
        setMenuOpen(false);

        // Controlla se è un anchor link
        if (href.includes('#')) {
            const [path, hash] = href.split('#');
            const targetPath = path || '/';

            // Se siamo già nella pagina corretta
            if (location.pathname === targetPath) {
                const elemento = document.getElementById(hash);
                if (elemento) {
                    const yOffset = -80;
                    const y = elemento.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            } else {
                // Naviga alla nuova pagina con l'hash
                navigate(targetPath + '#' + hash);
            }
        } else {
            // Link normale
            navigate(href);
        }
    };

    return (
        <header className="ef-account-header">
            <div className="ef-account-header__inner">
                <Link to="/" className="ef-account-header__brand" aria-label="Easy Funeral, pagina iniziale">
                    <img className="ef-header__brand-mark" src={logo} alt="" width="36" height="36" />
                    <span>Easy Funeral</span>
                </Link>
                <div className="ef-account-header__actions">
                <button
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="ef-account-header__toggle"
                    aria-label={menuOpen ? "Chiudi menu" : "Apri menu"}
                    aria-expanded={menuOpen}
                    aria-controls="ef-account-navigation"
                >
                    {menuOpen ? (
                        // Icona chiusura
                        <svg xmlns="http://www.w3.org/2000/svg" height="38" width="38" viewBox="0 0 640 640">
                            <path fill="#ffffff" d="M504.6 148.5C515.9 134.9 514.1 114.7 500.5 103.4C486.9 92.1 466.7 93.9 455.4 107.5L320 270L184.6 107.5C173.3 93.9 153.1 92.1 139.5 103.4C125.9 114.7 124.1 134.9 135.4 148.5L278.3 320L135.4 491.5C124.1 505.1 125.9 525.3 139.5 536.6C153.1 547.9 173.3 546.1 184.6 532.5L320 370L455.4 532.5C466.7 546.1 486.9 547.9 500.5 536.6C514.1 525.3 515.9 505.1 504.6 491.5L361.7 320L504.6 148.5z"/>
                        </svg>
                    ) : (
                        // Pulsante apertura
                        <svg xmlns="http://www.w3.org/2000/svg" height="38" width="38" viewBox="0 0 640 640">
                            <path fill="#ffffff" d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z"/>
                        </svg>
                    )}
                </button>
                </div>
            </div>

            {menuOpen && (
                <div
                    id="ef-account-navigation"
                    className="ef-account-header__menu"
                    onClick={() => setMenuOpen(false)}
                >
                    <nav aria-label="Area riservata">
                        {menuItems.map((item, index) => (
                            <a
                                key={index}
                                href={item.href}
                                className="ef-account-header__link"
                                onClick={(e) => handleClick(e, item.href)}
                            >
                                {item.label}
                            </a>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
}
